<template>
  <div>
    <template v-if="!isAuth">
      <v-btn rounded @click="login" :loading="!isInit" :disabled="!isInit">
        <v-icon left >{{ mdiLogin }}</v-icon>
        {{ $vuetify.lang.t('$vuetify.auth.SignIn') }}
      </v-btn>
    </template>
    <template v-else>
      <v-menu v-model="menu" transition="slide-y-transition" bottom :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-chip pill v-on="on">
            <v-avatar left size="32">
              <v-img :src="profilePicture"></v-img>
            </v-avatar>
            {{ $vuetify.lang.t('$vuetify.auth.profile') }}
          </v-chip>
        </template>

        <profile-card :profile-picture="profilePicture" :username="username" :email="email" :statistics="statistics"
                      @close="closeCard" @logout="logout" :is-init="isInit"></profile-card>

      </v-menu>
    </template>
  </div>
</template>

<script>
import { mdiLogin, mdiCloseCircle, mdiCarHatchback, mdiLogout } from '@mdi/js'
import { AUTH_MODULE, USER_STATISTICS_MODULE } from '../../store/modules'
import { createNamespacedHelpers } from 'vuex'
import { AUTH_LOGIN, AUTH_LOGOUT } from '../../store/actions'
import ProfileCard from '../utils/profileCard'
import { createHelpers } from 'vuex-map-fields'

const { mapActions, mapState } = createNamespacedHelpers(AUTH_MODULE)

const { mapFields } = createHelpers({
  getterType: `${USER_STATISTICS_MODULE}/getField`
})

export default {
  name: 'profileButton',
  components: { ProfileCard },
  data: () => ({
    mdiLogin: mdiLogin,
    mdiLogout: mdiLogout,
    mdiCloseCircle: mdiCloseCircle,
    mdiCarHatchback: mdiCarHatchback,
    menu: false,
    isInit: false
  }),
  computed: {
    ...mapState(['auth', 'profilePicture', 'email', 'username']),
    ...mapFields(['statistics']),
    isAuth () {
      return this.auth || process.env.VUE_APP_NO_AUTH
    }
  },
  methods: {
    ...mapActions([AUTH_LOGIN, AUTH_LOGOUT]),
    closeCard () {
      this.menu = false
    },
    async login () {
      await this[AUTH_LOGIN]()
    },
    async logout () {
      this.menu = false
      await this[AUTH_LOGOUT]()
    }
  },
  created () {
    let that = this
    let checkGauthLoad = setInterval(function () {
      that.isInit = that.$gAuth.isInit
      if (that.isInit) clearInterval(checkGauthLoad)
    }, 250)
  }
}
</script>

<style scoped>
</style>
